import React from 'react';
import { ThemeEnum } from '../../../../enum/Theme';
import { useTranslation } from 'react-i18next';

interface Props {
  theme: ThemeEnum;
  onToggle: () => void;
}

const ThemeToggle: React.FC<Props> = ({ theme, onToggle }) => {
  const { t } = useTranslation();

  const getThemeText = (): string => {
    return theme === ThemeEnum.DARK ? t('sidebar.user.dark') : t('sidebar.user.light');
  };

  return (
    <div className="wrapper" onClick={(e) => e.stopPropagation()}>
      <span className="label">{t('sidebar.user.selectedTheme')}</span>

      <button className="switch" data-theme={theme} onClick={onToggle}>
        <span className="thumb" />
        <span className="text">{getThemeText()}</span>
      </button>
    </div>
  );
};

export default ThemeToggle;
